// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"95c906c8","219":"296b4a7c","455":"399606b7","555":"e94592bf","797":"16a6b632","843":"f92e1406","852":"efabf713","910":"3fd0973d","936":"3c5abcd5","977":"8c72bf08"}[chunkId] + ".chunk.js";
};